import { ReportCount } from '@/types';
import client from './client';

interface GetReportsResponse {
  data: ReportCount[];
  isLast: boolean;
}

async function get({
  currentPage,
  limit,
  sortBy,
  sortOrder,
  searchQuery,
}: {
  currentPage: number;
  limit: number;
  sortBy: 'email' | 'count';
  sortOrder: 'asc' | 'desc';
  searchQuery: string;
}) {
  const { data } = await client.get<GetReportsResponse>('/reportsCount', {
    params: {
      currentPage,
      limit,
      sortBy,
      sortOrder,
      searchQuery,
    },
  });
  return data;
}

async function getAll() {
  const { data } = await client.get<ReportCount[]>('/reportsCount/export');
  return data;
}

export const reportsCount = {
  get,
  getAll,
};
